<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button
            @click="$utils.goBack($router)"
            text="Quay lại"
            defaultHref="/tabs/main"
          ></ion-back-button>
        </ion-buttons>
        <ion-title>Thiết lập tài khoản</ion-title>
        <ion-label slot="end" style="margin-right: 2vw"></ion-label>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list-header lines="full">
        <ion-label>Thiết lập bảo mật</ion-label>
      </ion-list-header>
      <ion-list>
        <ion-item button @click="$router.push('/account/personal/changepin')">
          <ion-icon
            slot="end"
            color="medium"
            size="small"
            :icon="lockOpen"
          ></ion-icon>
          <ion-label> Đổi mật mã PIN </ion-label>
        </ion-item>
        <ion-item button @click="changeUnlockMechanism">
          <ion-label slot="end" color="medium" size="small">{{ unlockMechanismTitle[unlockMechanism] }}</ion-label>
          <ion-label> Mở khóa ứng dụng </ion-label>
        </ion-item>
      </ion-list>

      <ion-list-header lines="full">
        <ion-label>Thông tin liên hệ</ion-label>
      </ion-list-header>
      <ion-list>
        <ion-item button @click="$router.push('/account/personal/editemail')">
          <ion-label> Email </ion-label>
          <ion-label slot="end" v-if="$store.state.auth.email">
            {{ $store.state.auth.email }}
          </ion-label>
          <ion-label slot="end" v-else color="medium"> (chưa có) </ion-label>
        </ion-item>
        <ion-item button @click="$router.push('/account/personal/editaddress')">
          <ion-label>
            <ion-text> Địa chỉ </ion-text>
            <p class="ion-text-wrap">
              {{ $store.state.auth.address.full }}
            </p>
          </ion-label>
        </ion-item>
      </ion-list>

      <ion-list-header
        lines="full"
        style="align-items: center; margin-top: 22px"
      >
        <ion-label style="margin-top: 6px">Thông tin tài khoản</ion-label>
        <ion-badge
          color="primary"
          style="margin-right: 5px"
          v-if="$store.state.auth.verificationStatus == 'approved'"
          >Đã xác thực</ion-badge
        >
        <ion-button
          style="margin-top: 6px"
          fill="outline"
          v-else
          @click="$router.push('/account/personal/editinfo')"
          >Sửa</ion-button
        >
      </ion-list-header>
      <ion-list>
        <ion-item>
          <ion-label color="medium">Xưng hô</ion-label>
          <ion-label slot="end">
            {{ $store.state.auth.title }}
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Họ và tên</ion-label>
          <ion-label slot="end">
            {{ $store.state.auth.fullName }}
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Ngày sinh</ion-label>
          <ion-label slot="end">
            {{ $moment($store.state.auth.dob).format("DD/MM/YYYY") }}
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label color="medium">CMND/CCCD</ion-label>
          <ion-label slot="end">
            {{ $store.state.auth.socialId }}
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Mã giới thiệu</ion-label>
          <ion-label slot="end">
            {{ $store.state.auth.referer }}
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Trạng thái</ion-label>
          <ion-label slot="end">
            <template v-if="$store.state.auth.verificationStatus != 'approved'">
              Chưa xác thực
            </template>
            <template v-else> Đã xác thực </template>
          </ion-label>
        </ion-item>
      </ion-list>
      <p
        v-if="$store.state.auth.verificationStatus == 'approved'"
        style="text-align: center"
      >
        <ion-button @click="requestModify" color="danger" fill="outline"
          >YÊU CẦU SỬA HỒ SƠ</ion-button
        >
      </p>
    </ion-content>
  </ion-page>
</template>

<style scoped>
</style>

<script>
import { defineComponent } from "vue";
import {
  IonPage,
  IonContent,
  IonHeader,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonToolbar,
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonButton,
  IonText,
  IonIcon,
  IonBadge,
  alertController,
  actionSheetController,
} from "@ionic/vue";
import { chevronForwardOutline, lockOpen, close } from "ionicons/icons";
import authService from "@/services/auth";
import { Plugins } from "@capacitor/core";

export default defineComponent({
  name: "Personal",
  components: {
    IonPage,
    IonContent,
    IonHeader,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonToolbar,
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonButton,
    IonText,
    IonIcon,
    IonBadge,
  },
  computed: {
    membership() {
      if (!(authService.user() && !authService.user().isAnonymous))
        return false;
      if (!this.$store.state.fsdb.customer) return false;
      return this.$store.state.fsdb.customer.membership;
    },
  },
  data() {
    return {
      unlockMechanismTitle: {
        pin: "Mã PIN",
        auto: "Tự động",
      },
      unlockMechanism: "pin",
    };
  },
  async ionViewWillEnter() {
    const { Storage } = Plugins;
    const savedPinRef = await Storage.get({
      key: "saved_pin",
    });
    this.unlockMechanism = savedPinRef.value ? "auto" : "pin";
  },
  methods: {
    async changeUnlockMechanism() {
      const actionSheet = await actionSheetController.create({
        header: "Chọn cơ chế mở khóa ứng dụng",
        buttons: [
          {
            text: "Mã PIN",
            handler: async () => {
              const { Storage } = Plugins;
              await Storage.set({
                key: "saved_pin",
                value: null,
              });
              this.unlockMechanism = 'pin';
            },
          },
          {
            text: "Tự động",
            handler: async () => {
              const { Storage } = Plugins;
              await Storage.set({
                key: "saved_pin",
                value: this.$store.state.auth.pin,
              });
              this.unlockMechanism = 'auto';
            },
          },
          {
            text: "Đóng",
            icon: close,
            role: "cancel",
            handler: () => {
              console.log("Cancel clicked");
            },
          },
        ],
      });
      await actionSheet.present();

      const { role } = await actionSheet.onDidDismiss();
      console.log("onDidDismiss resolved with role", role);
    },
    async requestModify() {
      const alert = await alertController.create({
        cssClass: "reg-alert",
        header: "Yêu cầu sửa hồ sơ",
        subheader: "Bạn có chắc muốn thay đổi hồ sơ cá nhân ?",
        message: "Tài khoản của bạn sẽ chuyển về trạng thái chưa xác thực",
        buttons: [
          {
            text: "Không",
            role: "cancel",
          },
          {
            text: "Đồng ý",
            cssClass: "alert-danger",
            handler: async () => {
              await this.$utils.showLoading();
              const resp = await this.$utils.callAPI(
                "POST",
                "/customers/verification",
                {
                  action: "invalidate",
                }
              );
              await this.$utils.hideLoading();
              if (resp.status >= 200 && resp.status <= 299) {
                if (resp.data && resp.data.message) {
                  (
                    await this.$utils.toast(resp.data.message, {
                      position: "top",
                      color: "primary",
                    })
                  ).present();
                }
                this.$store.commit("auth_update_info", {
                  verificationStatus: "unsubmitted",
                });
                this.$router.back();
              } else {
                if (resp.data && resp.data.message) {
                  (
                    await this.$utils.toast(resp.data.message, {
                      position: "top",
                    })
                  ).present();
                } else {
                  (
                    await this.$utils.toast(
                      "Có lỗi xảy ra từ máy chủ, quý khách vui lòng thử lại sau.",
                      { position: "top" }
                    )
                  ).present();
                }
              }
            },
          },
        ],
      });
      await alert.present();
    },
  },
  setup() {
    return {
      close,
      chevronForwardOutline,
      lockOpen,
    };
  },
});
</script>
